package io.horion.cv.components

import kotlinx.browser.document

private val FIELD_INPUT_IDS = mapOf(
    "lastName" to "input-lastName",
    "firstName" to "input-firstName",
    "bp" to "input-bp",
    "email" to "input-email",
    "phone" to "input-phone",
    "city" to "input-city"
)

fun focusMissingFieldFromPreview(
    fieldId: String?
) {
    val inputId = fieldId
        ?.let { FIELD_INPUT_IDS[it] }
        ?: return

    val element = document.getElementById(inputId)

    element?.asDynamic()?.focus()

    element?.asDynamic()?.scrollIntoView(
        js(
            "({ behavior: 'smooth', block: 'center' })"
        )
    )
}